import api from 'api';

export const getOperations = (params) => {
  return api.get('/operations', params, 'bearer');
};
